import React from 'react';
import permissionError from './../../src/images/img-error@2x.png';

export class ErrorPermission extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <article className='error'>
        <div className='error__body'>
          <div className='error__title'>表示権限エラー</div>
          <div className='error__image'>
            <img src={permissionError} alt='' />
          </div>
          <p className='error__message'>
            大変申し訳ございません。現在ご使用中の権限では
            指定されたページを開くことができません。Buildee管理者にお問い合わせ下さい。
          </p>
          <div className='error__button'>
            <a href='javascript:history.go(-2);' className='btn--sub'>
              戻る
            </a>
          </div>
          <div className='error__button'>
            <a href='/callback' className='btn--sub'>
              現場一覧に戻る
            </a>
          </div>
        </div>
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ErrorPermission.jsx